/**
 * Select options for the pillar page forms.
 *
 * Imported only by the client form islands — `country-state-city` is a large
 * dataset and should never be pulled into a server component graph.
 */
import { Country } from "country-state-city";
import type { SelectOption } from "@/components/ui/SearchableSelect";

export interface ContactFormState {
  firstName: string;
  lastName: string;
  email: string;
  countryCode: string;
  city: string;
  queryType: string;
  message: string;
}

export const EMPTY_CONTACT: ContactFormState = {
  firstName: "",
  lastName: "",
  email: "",
  countryCode: "",
  city: "",
  queryType: "",
  message: "",
};

export interface FeedbackFormState {
  name: string;
  email: string;
  role: string;
  type: string;
  message: string;
}

export const EMPTY_FEEDBACK: FeedbackFormState = {
  name: "",
  email: "",
  role: "",
  type: "",
  message: "",
};

export const FEEDBACK_ROLE_OPTIONS: SelectOption[] = [
  "Real Estate Agent",
  "Senior Broker",
  "Real Estate Company / Agency",
  "Property Developer",
  "Property Manager",
  "Off-Plan Specialist",
  "Other Real Estate Professional",
].map((label) => ({ value: label, label }));

export const FEEDBACK_TYPE_OPTIONS: SelectOption[] = [
  "Feature Suggestion",
  "Bug / Issue Report",
  "General Feedback",
  "Positive Experience",
  "Content / Profile Issue",
  "Off-Plan Data Query",
].map((label) => ({ value: label, label }));

export const QUERY_TYPE_OPTIONS: SelectOption[] = [
  "App Issue / Bug Report",
  "Feature Query",
  "Account Help",
  "Off-Plan Data Query",
  "Partnership Enquiry",
  "General Question",
].map((label) => ({ value: label, label }));

// All countries as SelectOptions, sorted A-Z
export const ALL_COUNTRIES: SelectOption[] = Country.getAllCountries()
  .sort((a, b) => a.name.localeCompare(b.name))
  .map((c) => ({ value: c.isoCode, label: c.name, flag: c.flag }));
